<template>
  <div class="container mx-auto my-8 px-4 lg:px-0">

    <div class="mb-8 flex flex-wrap flex-col-reverse lg:flex-row justify-between items-center">
      <search-input
        class="w-full lg:max-w-sm mr-0 lg:mr-4 shadow"
        placeholder="Zoeken op naam.."
        @searched="onSearched">
      </search-input>
      <div class="buttons mb-6 lg:mb-0 self-start lg:self-center" v-if="$contact.isAllowed('create')">
        <router-link :to="{ name: 'organization-new' }" class="btn py-3 text-sm text-white bg-green-dark font-semibold">
          <span>Nieuw</span>
          <span class="hidden md:inline ml-1">Organisatie</span>
        </router-link>
      </div>
    </div>

    <div class="bg-white shadow overflow-x-auto">
      <table class="custom w-full whitespace-no-wrap">
        <thead>
          <tr class="text-left text-green-darker">
            <th class="px-6">Naam</th>
            <th class="px-6">Straat</th>
            <th class="px-6" colspan="2">Gewijzigd op</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="organization in organizations.data" :key="organization.id" class="hover:bg-grey-lightest text-grey-darker">
            <td class="border-t border-grey-lighter">
              <router-link :to="{ name: 'organization', params: { id: organization.id } }" class="flex items-center px-6 py-4">
                {{ organization.name }}
              </router-link>
            </td>
            <td class="border-t border-grey-lighter">
              <router-link :to="{ name: 'organization', params: { id: organization.id } }" class="flex items-center px-6 py-4">
                {{ organization.street }}
              </router-link>
            </td>
            <td class="border-t border-grey-lighter">
              <router-link :to="{ name: 'organization', params: { id: organization.id } }" class="flex items-center px-6 py-4">
                {{ organization.updated_at }}
              </router-link>
            </td>
            <td class="border-t border-grey-lighter w-px">
              <router-link :to="{ name: 'organization', params: { id: organization.id } }" class="flex items-center px-6 py-4">
                <font-awesome-icon :icon="['fas', 'angle-right']" class="icon" />
              </router-link>
            </td>
          </tr>
          <tr v-if="organizations.data && organizations.data.length === 0">
            <td class="border-t border-grey-lighter px-6 py-4" colspan="4">Geen organisaties gevonden.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <base-pagination
      class="mt-2"
      v-if="organizations.meta && organizations.meta.last_page > 1"
      :total-pages="organizations.meta.last_page"
      :total="10"
      :current-page="organizations.meta.current_page"
      @page-changed="onPageChanged">
    </base-pagination>

  </div>
</template>

<script>
import ContactPerimeter from '@/perimeters/contact';
import ApiService from '@/common/api.service';
import SearchInput from '@/components/inputs/Search';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'OrganizationList',
  perimeters: [ContactPerimeter],
  components: {
    FontAwesomeIcon,
    SearchInput
  },
  created() {
    this.fetch(this.$route.query.page);
  },
  data() {
    return {
      organizations: {}
    };
  },
  methods: {
    fetch(page = 1) {
      let params = { page: page, sort: 'name' };

      ApiService.query('/v1/contacts', { params: params }).then(
        response => (this.organizations = response.data)
      );
    },
    onPageChanged(page) {
      this.$router.push({ name: 'organizations', query: { page: page } });
    },
    onSearched(keyword) {
      if (!keyword) {
        return this.fetch();
      }

      ApiService.get('/v1/contacts', `search?filter[name]=${keyword}`).then(
        response => (this.organizations = response.data)
      );
    }
  }
};
</script>
